// extracted by mini-css-extract-plugin
export var callCard = "_rf-0";
export var callMessageButton = "_rf-1";
export var helpIcon = "_rf-3";
export var helpIconContainer = "_rf-4";
export var verticalDivider = "_rf-2";